import { Helpers } from '../../helpers';
import { ILinerType } from '../../interfaces/iliner-type';
import { ProjectPondParameter } from '../project-pond-parameter';

export class LinerTypeBase {
  LinerTypeId: number;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectPondParameters_LinerType?: Array<ProjectPondParameter> | null;

  constructor(item?: ILinerType) {
    if (item) {

      this.LinerTypeId = item.LinerTypeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectPondParameters_LinerType = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_LinerType);
    }
  }
}